import { memo, useCallback, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { TIMER_GET_LIVE } from '@zmedia/bm-soccer-ui/constants';
import { IEventPen } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils, Logger } from '@zmedia/bm-soccer-ui/utils';
import MatchService from '@zmedia/bm-soccer-ui/service/MatchService';
import { LiveService } from '@zmedia/bm-soccer-ui/service/LiveService';
import {
    Element,
    Icon,
    Level,
    List,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import styles from './style.module.scss';

function PenShootout({ id, isLive }: { id: number; isLive: boolean }) {
    const timeout = useRef<any>(0);

    const [data, setData] = useState<any>({});
    const { items = [] } = data;

    const fetchData = (id: number) => {
        const fetch = isLive
            ? LiveService.getPenShootout
            : MatchService.getPenShootout;
        fetch(id)
            .then((resp) => {
                if (resp && resp.data) {
                    const { items = [] } = resp.data;
                    if (!ArrayUtils.isEmpty(items)) {
                        const data = resp.data || {};
                        setData(data);
                    }
                    if (isLive) {
                        timeout.current = setTimeout(() => {
                            fetchData(id);
                        }, TIMER_GET_LIVE);
                    }
                }
            })
            .catch((err) => {
                if (err) {
                    Logger.error(err.err, 'getEventsInMatch fail|', err);
                }
            });
    };

    useEffect(() => {
        if (id) {
            fetchData(id);
        }
        return () => {
            clearTimeout(timeout.current);
        };
    }, [id, isLive]);

    const renderEvent = (event: IEventPen) => {
        return (
            <Element className={styles['event-player']}>
                <Avatar avatar={event?.player?.avatar} name={event?.player?.name}/>
                <Element className={styles['text']}>
                    {event?.player?.shortName}
                </Element>
                <Icon
                    icon="goal"
                    style={{ color: !event.status ? 'red' : '' }}
                ></Icon>
            </Element>
        );
    };

    const renderEvents = useCallback(() => {
        return [...items].reverse().map((item: IEventPen, index: number) => {
            return (
                <List.Item key={index}>
                    <Level>
                        <Level.Side align="left">
                            {item.fromTeam === 'home' ? (
                                <>{renderEvent(item)}</>
                            ) : (
                                <>&nbsp;</>
                            )}
                        </Level.Side>
                        <Level.Side align="center">
                            <Element className={styles['scores']}>
                                <Element
                                    className={cn({
                                        [styles['is-goal']]:
                                            item.fromTeam === 'home',
                                    })}
                                >
                                    {item.hScore}
                                </Element>
                                -
                                <Element
                                    className={cn({
                                        [styles['is-goal']]:
                                            item.fromTeam === 'away',
                                    })}
                                >
                                    {item.aScore}
                                </Element>
                            </Element>
                        </Level.Side>
                        <Level.Side align="right">
                            {item.fromTeam === 'away' ? (
                                <>{renderEvent(item)}</>
                            ) : (
                                <>&nbsp;</>
                            )}
                        </Level.Side>
                    </Level>
                </List.Item>
            );
        });
    }, [items]);

    if (ArrayUtils.isEmpty(items)) {
        return null;
    }

    return (
        <Element className={styles['pen-shootout-list']}>
            <Title subtitle>Loạt sút luân lưu</Title>
            <List>{renderEvents()}</List>
        </Element>
    );
}
export default memo(PenShootout);
